module.exports = __webpack_public_path__ + "static/img/NOTICE.659f3e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PageCommon/img/NOTICE.jpg
// module id = RgGd
// module chunks = 89